<template>
	<div>
		<header class="header">
		<button type="button" class="navbar-toggle" @click="isOpened = !isOpened"></button>
		<label class="logo logo-title">АТЛАС</label>
		<label class="logo logo-title" v-if="title">- {{title}}</label>
		<a v-if="isAuthenticated" class="nav-right nav-right-logout" v-bind:href="cas_logout_url">
			<b-icon icon="box-arrow-right" font-scale="2" style="" ></b-icon>
		</a>
		<router-link @click.native="isOpened = false" v-if="userAuthenticated" class="nav-right" :to="{ name: 'profile' }">
			<span class="fa fa-profile"></span>
			<span class="list-group-item-value">{{userAuthenticated}}</span>
		</router-link>
		<a v-if="!isAuthenticated" class="nav-right" v-bind:href="cas_login_url">
			<span class="fa fa-login" ></span>
			<span class="list-group-item-value">Войти</span>
		</a>
		</header>
		<transition name="slide">
		<div v-if="isOpened" class="navbar-menu">
			<ul class="list-group">
			<li v-if="isAuthenticated" class="list-group-item list-group-item-moved">
				<router-link @click.native="isOpened = false" :to="{ name: 'profile' }">
				<span class="fa fa-profile"></span>
				<span class="list-group-item-value">{{userAuthenticated}}</span>
				</router-link>
			</li>
			<li class="list-group-item">
				<a v-bind:href="viewer_url">
				<span class="fa fa-viewer"></span>
				<span class="list-group-item-value">Карта</span>
				</a>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_users' }">
				<span class="fa fa-manager-users"></span>
				<span class="list-group-item-value">Пользователи</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_roles' }">
				<span class="fa fa-manager-roles"></span>
				<span class="list-group-item-value">Роли</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_layers' }">
				<span class="fa fa-manager-layers"></span>
				<span class="list-group-item-value">Слои</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_layergroups' }">
				<span class="fa fa-manager-layergroups"></span>
				<span class="list-group-item-value">Группы слоев</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_workspaces' }">
				<span class="fa fa-manager-workspaces"></span>
				<span class="list-group-item-value">Рабочие области</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_datastores' }">
				<span class="fa fa-manager-datastorage"></span>
				<span class="list-group-item-value">Хранилища</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_maps' }">
				<span class="fa fa-manager-maps"></span>
				<span class="list-group-item-value">Карты</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_fonmaps' }">
				<span class="fa fa-fonmaps-maps"></span>
				<span class="list-group-item-value">Подложки</span>
				</router-link>
			</li>
			<li v-if="hasRole('ROLE_MANAGER')" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'manager_topics' }">
				<!-- <span class="fa fa-manager-topics"></span> -->
				<span class="list-group-item-value">Тематические разделы</span>
				</router-link>
			</li>
			<li v-if="isAuthenticated" class="list-group-item list-group-item-moved">
				<a v-bind:href="cas_logout_url">
				<span class="fa fa-logout"></span>
				<span class="list-group-item-value">Выйти</span>
				</a>
			</li>
			<li v-if="!isAuthenticated" class="list-group-item list-group-item-moved">
				<a v-bind:href="cas_login_url">
				<span class="fa fa-login"></span>
				<span class="list-group-item-value">Войти</span>
				</a>
			</li>
			<li v-if="!isAuthenticated" class="list-group-item">
				<router-link @click.native="isOpened = false" :to="{ name: 'register' }">
				<span class="fa fa-register"></span>
				<span class="list-group-item-value">Регистрация</span>
				</router-link>
			</li>
			</ul>
		</div>
		</transition>
		<transition name="overlay">
		<div v-if="isOpened" class="navbar-overlay" @click="isOpened = false">
		</div>
		</transition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Header',
	data () {
		return {
			isOpened: false,
			title: '',
			viewer_url: process.env.VIEWER_URL,
			cas_login_url: process.env.CAS_URL + "/login?locale=ru&service=" + window.location.href,
			cas_logout_url: process.env.CAS_URL + "/logout?locale=ru"
		}
	},
	methods: {
		setTitle () {
		var title = this.$route.meta.title
		this.title = title
		}
	},
	created () {
		this.setTitle()
	},
	watch: {
		'$route': 'setTitle'
	},
	computed: {
		...mapGetters([
		'userAuthenticated',
		'hasRole',
		'isAuthenticated'
		])
	}
}
</script>

<style scoped>
header {
	height: 60px;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 1030;
	background-color: rgba(68, 110, 202, 1);
	transition: all .2s cubic-bezier(.35,0,.25,1);
	box-shadow: rgb(156 156 156) 0px 2px 2px;
}
.slide-enter-active {
	transition: all .5s ease;
}
.slide-leave-active {
	transition: all .5s ease;
}
.slide-enter, .slide-leave-to {
	transform: translateX(-200px);
	opacity: 0;
}
.navbar-overlay {
	height: 100%;
	width: 100%;
	z-index: 1020;
	top: 0;
	left: 0;
	position: fixed;
	background: black;
	opacity: 0.7;
}
.overlay-enter-active {
	transition: all .3s ease;
}
.overlay-leave-active {
	transition: all .3s ease;
}
.overlay-enter, .overlay-leave-to {
	opacity: 0;
}
.navbar-toggle {
	background-color: transparent;
	border: 0px solid transparent;
	background-image: url("~@/assets/menu.png");
	background-size: contain;
	cursor: pointer;
	padding: 30px;
	margin-left: 15px;
	height: 0;
	width: 0;
	float: left;
}
.navbar-toggle:focus {
	outline: 0;
}
.logo {
	background-color: transparent;
	text-decoration: none;
	font-size: 35px;
	line-height: 60px;
	color: #fff;
	float: left;
	margin-left: 15px;
}

.nav-right {
	text-decoration: none;
	cursor: pointer;
	font-size: 14px;
	line-height: 26px;
	padding: 18px 20px 17px 25px;
	position: relative;
	white-space: nowrap;
	/* width: 250px; */
	display: flex;
	float: right;
	background-color: #60b7ff;
	color: #fff;
	font-weight: 600;
	height: 100%
}

.nav-right:hover {
	background-color: #4e9dde;
}
.navbar-menu {
	background: rgb(107, 158, 234);
	/* border-right: 1px solid #292e34; */
	bottom: 0;
	left: 0;
	overflow-x: hidden;
	overflow-y: auto;
	position: fixed;
	top: 60px;
	width: 250px;
	z-index: 1030;
}
.list-group-item {
	position: relative;
	display: block;
	margin-bottom: -1px;
	border: 1px solid #f5f5f5;
	border-left: 0;
	border-right: 0;
	background-color: transparent;
	border-color: #030303;
	padding: 0;
}
.list-group-item:first-child {
	border-top: 0;
}
.list-group-item:last-child {
	margin-bottom: 0;
}
.list-group-item > a {
	text-decoration: none;
	background-color: transparent;
	color: #e4e4e4;
	cursor: pointer;
	display: block;
	font-size: 14px;
	font-weight: 400;
	height: 63px;
	line-height: 26px;
	padding: 17px 20px 17px 25px;
	position: relative;
	white-space: nowrap;
	width: 250px;
	display: flex;
	padding-right: 0;
}
.list-group-item .router-link-active,
.list-group-item:hover a {
	background-color: #60b7ff;
	color: #fff;
	font-weight: 600;
}
.list-group-item .router-link-active:before {
	background: #446eca;
	content: " ";
	height: 100%;
	left: 0;
	position: absolute;
	top: 0;
	width: 3px;
}
.list-group-item-value {
	display: block;
	line-height: 25px;
	max-width: 120px;
	overflow: hidden;
	text-overflow: ellipsis;
	-ms-flex: 1;
	flex: 1;
	max-width: none;
	padding-right: 15px;
}
.fa {
	display: inline-block;
	font-size: inherit;
	text-rendering: auto;
	-webkit-font-smoothing: antialiased;
	color: #72767b;
	font-size: 20px;
	line-height: 26px;
	margin-right: 10px;
	text-align: center;
	width: 24px;
	background-size: contain;
	background-repeat: no-repeat;
}
.fa-register {
	background-image: url("~@/assets/add-new-user.png");
}
.fa-manager {
	background-image: url("~@/assets/tones.png");
}
.fa-profile {
	background-image: url("~@/assets/user.png");
}
.fa-viewer {
	background-image: url("~@/assets/worldwide.png");
}
.fa-manager-users {
	background-image: url("~@/assets/team.png");
}
.fa-manager-roles {
	background-image: url("~@/assets/bank-card.png");
}
.fa-manager-layers {
	background-image: url("~@/assets/layers.png");
}
.fa-manager-workspaces {
	background-image: url("~@/assets/open-box.png");
}
.fa-manager-maps {
	background-image: url("~@/assets/world-wide-web.png");
}
.fa-manager-datastorage {
	background-image: url("~@/assets/datastorage.png");
}
.fa-fonmaps-maps {
	background-image: url("~@/assets/fonmaps.png");
}
.fa-manager-layergroups {
	background-image: url("~@/assets/layerGroup.png");
}
.fa-login {
	background-image: url("~@/assets/key.png");
}
.fa-logout {
	background-image: url("~@/assets/logout.png");
}
.nav-right-logout {
	border-left:1px solid white;
}
.nav-right-logout .fa-logout {
	margin-right: 0;
}
/* .fa-manager-topics {
  background-image: url("~@/assets/topics.png");
} */

@media only screen and (max-width: 700px) {
	.nav-right {
		display: none;
	}
	.logo-title {
		display: none;
	}
}
@media only screen and (min-width: 701px) {
	.list-group-item-moved {
		display: none;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/views/Shared/Header.vue